<div id="milestone" class="timeline-card-container" (contextmenu)="onContextMenu($event)">
  <div class="timeline-card" data-testid="card" (click)="onCardClick()">
    <!-- Icon Column -->
    <div class="card-icon">
      <svg width="100%" height="100%" viewBox="0 0 102 100">
        <g transform="translate(-2999.4760342794557 753.6489657205448)" >
          <path
            d="M3045.76-748.88a6 6 0 0 1 8.48 0l41.52 41.5a6 6 0 0 1 0 8.5l-41.52 41.5a6 6 0 0 1-8.48 0l-41.52-41.5a6 6 0 0 1 0-8.5z"
            stroke="#1071e5" stroke-width="6" fill="#fff"/>
        </g>
      </svg>
    </div>
    
    <!-- Content Column -->
    <div class="card-content">
      <!-- Status Tag (Always at top-right) -->
      <div class="status-container">
        @if (milestone.isVisible == false) {
          <span class="hidden-indicator" title="Hidden">
            <rds-icon namespace="filled" icon="visibility_off"></rds-icon>
          </span>
        }
      </div>
      
      <!-- Title -->
      <h3 class="card-title" data-testid="projectName">{{ milestone.metadata.projectName }}</h3>
      
      <!-- Strategic Pillar (Optional) -->
      @if ((milestone.strategicPillars && milestone.strategicPillars.length > 0) || (milestone.audiences && milestone.audiences.length > 0)) {
        <div class="tags-container">
          @if (milestone.strategicPillars && milestone.strategicPillars.length > 0) {
            @for (sp of milestone.strategicPillars; track sp) {
              <span class="strategic-pillar-tag" 
                    [style.background-color]="sp.color_code"
        [style.color]="getContrastColor(sp.color_code)"
                    [title]="'Strategic Pillar: ' + sp.title">
                {{ sp.title }}
              </span>
            }
          }
          @if (milestone.audiences && milestone.audiences.length > 0) {
            @for (aud of milestone.audiences; track aud) {
              <span class="veeva-audience-tag"
                    [title]="'Audience: ' + aud.name">
                {{ aud.name }}
              </span>
            }
          }
        </div>
      }
      
      <!-- Activity Name (Subtitle) -->
      <p class="card-subtitle" data-testid="activityName">{{ milestone.metadata.activityName }}</p>
      
      <!-- Keywords -->
      <div class="keywords-container">
        @for (keyword of milestone.keyWords; track keyword) {
          <span class="keyword-tag" data-testclass="keyword">{{ keyword }}</span>
        }
      </div>
    </div>
  </div>
</div>
